import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "bf-heading-script text-primary mt-3 mb-3" }, "Dein Anmeldestatus", -1)
const _hoisted_2 = {
  key: 0,
  class: "mt-5 text-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-3x fa-spin fa-spinner" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Es ist ein Fehler aufgetreten – bitte versuche es später erneut.")
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "bf-enrollment-status mb-3" }
const _hoisted_9 = { class: "bf-enrollment-status__entry" }
const _hoisted_10 = { class: "bf-enrollment-status__entry" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Terminanmeldung", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!
  const _component_AppointmentEnrollment = _resolveComponent("AppointmentEnrollment")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_Alert, { type: "danger" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _withDirectives(_createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("i", {
                  class: _normalizeClass(["fa fa-fw me-1", _ctx.courseIconClass])
                }, null, 2),
                _createElementVNode("span", null, _toDisplayString(_ctx.isWaitingForCourse ? 'Kurs-Warteliste' : 'Kursanmeldung'), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("i", {
                  class: _normalizeClass(["fa fa-fw me-1", _ctx.appointmentIconClass])
                }, null, 2),
                _hoisted_11
              ])
            ], 512), [
              [_vShow, _ctx.showStatus]
            ]),
            _createVNode(_component_AppointmentEnrollment, {
              "appointment-id": _ctx.appointmentId,
              "region-id": _ctx.regionId,
              onLogin: _ctx.loadEnrollmentStatus,
              onEnrollment: _ctx.onEnrollmentStatusChange,
              onWithdrawal: _ctx.onEnrollmentStatusChange
            }, null, 8, ["appointment-id", "region-id", "onLogin", "onEnrollment", "onWithdrawal"])
          ]))
  ]))
}